var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "contents" },
    [
      _c("div", { staticClass: "header" }, [
        _c("div", { staticClass: "tab" }, [
          _c(
            "span",
            {
              directives: [
                {
                  name: "permissson",
                  rawName: "v-permissson",
                  value: "CKXX",
                  expression: "'CKXX'",
                },
              ],
              staticClass: "tabItem",
              class: { active: _vm.active === 0 },
              on: {
                click: function ($event) {
                  return _vm.changeType(0, "CKXX")
                },
              },
            },
            [_vm._v(" 仓库信息 ")]
          ),
          _c(
            "span",
            {
              directives: [
                {
                  name: "permissson",
                  rawName: "v-permissson",
                  value: "TTXX",
                  expression: "'TTXX'",
                },
              ],
              staticClass: "tabItem",
              class: { active: _vm.active === 1 },
              on: {
                click: function ($event) {
                  return _vm.changeType(1, "TTXX")
                },
              },
            },
            [_vm._v(" 抬头信息 ")]
          ),
          _c(
            "span",
            {
              directives: [
                {
                  name: "permissson",
                  rawName: "v-permissson",
                  value: "MT",
                  expression: "'MT'",
                },
              ],
              staticClass: "tabItem",
              class: { active: _vm.active === 2 },
              on: {
                click: function ($event) {
                  return _vm.changeType(2, "MT")
                },
              },
            },
            [_vm._v(" 码头 ")]
          ),
          _c(
            "span",
            {
              directives: [
                {
                  name: "permissson",
                  rawName: "v-permissson",
                  value: "CSHS",
                  expression: "'CSHS'",
                },
              ],
              staticClass: "tabItem",
              class: { active: _vm.active === 3 },
              on: {
                click: function ($event) {
                  return _vm.changeType(3, "CSHS")
                },
              },
            },
            [_vm._v(" 船司航司 ")]
          ),
          _c(
            "span",
            {
              directives: [
                {
                  name: "permissson",
                  rawName: "v-permissson",
                  value: "CM",
                  expression: "'CM'",
                },
              ],
              staticClass: "tabItem",
              class: { active: _vm.active === 4 },
              on: {
                click: function ($event) {
                  return _vm.changeType(4, "CM")
                },
              },
            },
            [_vm._v(" 船名 ")]
          ),
        ]),
        _c(
          "div",
          { staticClass: "optheader" },
          [
            _vm.active < 4
              ? _c(
                  "div",
                  { staticClass: "search" },
                  [
                    _c("el-input", {
                      staticClass: "input-search",
                      attrs: {
                        placeholder: `${
                          _vm.active !== 2 && _vm.active !== 3
                            ? "请输入公司名称"
                            : "请输入代码"
                        }`,
                      },
                      nativeOn: {
                        keydown: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.search.apply(null, arguments)
                        },
                      },
                      model: {
                        value: _vm.searchVal,
                        callback: function ($$v) {
                          _vm.searchVal = $$v
                        },
                        expression: "searchVal",
                      },
                    }),
                    _c(
                      "div",
                      { staticClass: "btn-search", on: { click: _vm.search } },
                      [_c("i", { staticClass: "el-icon-search" })]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.active === 1
              ? _c(
                  "el-select",
                  {
                    staticStyle: { width: "200px" },
                    attrs: {
                      filterable: "",
                      clearable: "",
                      placeholder: "请选择信息类型",
                      size: "mini",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.getSicnList(_vm.pager)
                      },
                    },
                    model: {
                      value: _vm.types,
                      callback: function ($$v) {
                        _vm.types = $$v
                      },
                      expression: "types",
                    },
                  },
                  _vm._l(_vm.sicnOptions, function (item) {
                    return _c("el-option", {
                      key: item.value,
                      attrs: { label: item.label, value: item.value },
                    })
                  }),
                  1
                )
              : _vm._e(),
            _vm.active === 0
              ? _c("div", { staticClass: "type-tab" }, [
                  _c(
                    "span",
                    {
                      class: [_vm.typeActive === -1 && "active"],
                      on: {
                        click: function ($event) {
                          return _vm.handleTypeChange(-1)
                        },
                      },
                    },
                    [_vm._v("全部")]
                  ),
                  _c(
                    "span",
                    {
                      class: [_vm.typeActive === 0 && "active"],
                      on: {
                        click: function ($event) {
                          return _vm.handleTypeChange(0)
                        },
                      },
                    },
                    [_vm._v("私仓")]
                  ),
                  _c(
                    "span",
                    {
                      class: [_vm.typeActive === 1 && "active"],
                      on: {
                        click: function ($event) {
                          return _vm.handleTypeChange(1)
                        },
                      },
                    },
                    [_vm._v("亚马逊仓")]
                  ),
                  _c(
                    "span",
                    {
                      class: [_vm.typeActive === 100 && "active"],
                      on: {
                        click: function ($event) {
                          return _vm.handleTypeChange(100)
                        },
                      },
                    },
                    [_vm._v("沃尔玛仓")]
                  ),
                ])
              : _vm._e(),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.newAdd,
                    expression: "newAdd",
                  },
                ],
                staticClass: "add flex_c_c",
                attrs: { "v-permissson": _vm.newAdd },
                on: { click: _vm.add },
              },
              [
                _c("svg-icon", {
                  attrs: { className: "icon", iconClass: "add" },
                }),
                _vm._v("新增 "),
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.exportFile,
                    expression: "exportFile",
                  },
                ],
                staticClass: "add flex_c_c",
                attrs: { "v-permissson": _vm.exportFile },
                on: { click: _vm.downloadFile },
              },
              [_c("i", { staticClass: "el-icon-download" }), _vm._v(" 导出 ")]
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "data" },
        [
          _vm.height !== 0
            ? _c("BaseTable", {
                attrs: {
                  height: _vm.height,
                  tableData: {
                    ..._vm.tableData,
                    fileds: _vm.fileds,
                    columns: _vm.columns,
                  },
                  pageIndex: _vm.pager.pageIndex,
                  pageSize: _vm.pager.pageSize,
                  loading: _vm.loading,
                  isEmptyBorder: true,
                },
                on: { handlePageChange: _vm.handlePageChange },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "isActived",
                      fn: function (row) {
                        return [
                          _c(
                            "div",
                            {
                              class: [
                                "flex_c_c",
                                "isActived",
                                row.scope.isActived
                                  ? "isActived1"
                                  : "isActived2",
                              ],
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    row.scope.isActived ? "启用" : "停用"
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "type",
                      fn: function (row) {
                        return [
                          _c(
                            "div",
                            {
                              class: [
                                "warehouseType",
                                `warehouseType${row.scope.type}`,
                                "flex_c_c",
                              ],
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("formatWarehouseType")(
                                      row.scope.type
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "attentionName",
                      fn: function (row) {
                        return [
                          _c(
                            "div",
                            { staticClass: "infobox" },
                            [
                              _c(
                                "el-row",
                                { staticStyle: { display: "flex" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "infoItem",
                                      staticStyle: { "min-width": "145px" },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "label label1" },
                                        [_vm._v("公司")]
                                      ),
                                      _c("span", { staticClass: "num" }, [
                                        _vm._v(_vm._s(row.scope.companyName)),
                                      ]),
                                    ]
                                  ),
                                  _c("div", { staticClass: "infoItem" }, [
                                    _c(
                                      "span",
                                      { staticClass: "label label1" },
                                      [_vm._v("联系人")]
                                    ),
                                    _c("span", { staticClass: "num" }, [
                                      _vm._v(
                                        _vm._s(
                                          row.scope.contact ||
                                            row.scope.attentionName
                                        )
                                      ),
                                    ]),
                                  ]),
                                ]
                              ),
                              _c(
                                "el-row",
                                { staticStyle: { display: "flex" } },
                                [
                                  _c("div", { staticClass: "infoItem" }, [
                                    _c(
                                      "span",
                                      { staticClass: "label label1" },
                                      [_vm._v("电话")]
                                    ),
                                    _c("span", { staticClass: "num" }, [
                                      _vm._v(_vm._s(row.scope.phoneNumber)),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "infoItem" }, [
                                    _c(
                                      "span",
                                      { staticClass: "label label1" },
                                      [_vm._v("邮箱")]
                                    ),
                                    _c("span", { staticClass: "num" }, [
                                      _vm._v(_vm._s(row.scope.email)),
                                    ]),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: "countryName",
                      fn: function (row) {
                        return [
                          _c(
                            "div",
                            { staticClass: "infobox" },
                            [
                              _c(
                                "el-row",
                                { staticStyle: { display: "flex" } },
                                [
                                  _c("div", { staticClass: "infoItem" }, [
                                    _c(
                                      "span",
                                      { staticClass: "label label1" },
                                      [_vm._v("国家")]
                                    ),
                                    _c("span", { staticClass: "num" }, [
                                      _vm._v(
                                        _vm._s(
                                          row.scope.countryName ||
                                            row.scope.countryCode
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "infoItem" }, [
                                    _c(
                                      "span",
                                      { staticClass: "label label4" },
                                      [_vm._v("省州")]
                                    ),
                                    _c("span", { staticClass: "num" }, [
                                      _vm._v(
                                        _vm._s(
                                          row.scope.provinceEnName ||
                                            row.scope.provinceName ||
                                            row.scope.state
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "infoItem" }, [
                                    _c(
                                      "span",
                                      { staticClass: "label label4" },
                                      [_vm._v("城市")]
                                    ),
                                    _c("span", { staticClass: "num" }, [
                                      _vm._v(
                                        _vm._s(
                                          row.scope.cityAddress ||
                                            row.scope.city
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "infoItem" }, [
                                    _c(
                                      "span",
                                      { staticClass: "label label4" },
                                      [_vm._v("邮编")]
                                    ),
                                    _c("span", { staticClass: "num" }, [
                                      _vm._v(
                                        _vm._s(
                                          row.scope.postalCode ||
                                            row.scope.postcode
                                        )
                                      ),
                                    ]),
                                  ]),
                                ]
                              ),
                              row.scope.address
                                ? _c("el-row", [
                                    _c("div", { staticClass: "infoItem" }, [
                                      _c(
                                        "span",
                                        { staticClass: "label label1" },
                                        [_vm._v("地址")]
                                      ),
                                      _c("span", { staticClass: "num" }, [
                                        _vm._v(_vm._s(row.scope.address)),
                                      ]),
                                    ]),
                                  ])
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: "typeNames",
                      fn: function (row) {
                        return _vm._l(
                          row.scope.typeNames,
                          function (item, $index) {
                            return _c("el-tag", { key: $index }, [
                              _vm._v(" " + _vm._s(item) + " "),
                            ])
                          }
                        )
                      },
                    },
                    {
                      key: "opt",
                      fn: function (row) {
                        return [
                          _vm.active !== 4
                            ? _c(
                                "el-popover",
                                {
                                  ref: `popover${row.scope.id}`,
                                  attrs: {
                                    placement: "bottom-start",
                                    "popper-class": "pop-table-opt",
                                    width: "114",
                                    trigger: "click",
                                  },
                                },
                                [
                                  _c("div", { staticClass: "table-opt" }, [
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "permissson",
                                                rawName: "v-permissson",
                                                value: "update",
                                                expression: "'update'",
                                              },
                                            ],
                                            staticClass: "opt-item",
                                            on: {
                                              click: function ($event) {
                                                return _vm.updateWarehouse(
                                                  row.scope
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("修改")]
                                        ),
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "opt-item",
                                            on: {
                                              click: function ($event) {
                                                return _vm.deleteWarehouse(
                                                  row.scope
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("删除")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]),
                                  _c("img", {
                                    attrs: {
                                      slot: "reference",
                                      src: require("@/assets/images/table/opt.png"),
                                    },
                                    slot: "reference",
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                    {
                      key: "companyName",
                      fn: function (row) {
                        return [
                          _vm._v(" " + _vm._s(row.scope.companyName) + " "),
                        ]
                      },
                    },
                    {
                      key: "name",
                      fn: function (row) {
                        return [_vm._v(" " + _vm._s(row.scope.name) + " ")]
                      },
                    },
                  ],
                  null,
                  false,
                  2715168131
                ),
              })
            : _vm._e(),
        ],
        1
      ),
      _c("WarehouseDialog", {
        attrs: { dialogVisible: _vm.dialogVisible, editData: _vm.editData },
        on: { ok: _vm.ok, cancel: _vm.cancel },
      }),
      _c("WarehouseAddDialog", {
        attrs: {
          dialogVisible: _vm.dialogVisible1,
          editData: _vm.editData1,
          activeName: _vm.activeName,
          isSelectType: _vm.isSelectType,
        },
        on: { ok: _vm.ok, cancel: _vm.cancel },
      }),
      _c("AddHarborDialog", {
        attrs: { dialogVisible: _vm.dialogVisible5, editData: _vm.editData1 },
        on: { ok: _vm.ok, cancel: _vm.cancel },
      }),
      _c("AddLineDialog", {
        attrs: { dialogVisible: _vm.dialogVisible6, editData: _vm.editData1 },
        on: { ok: _vm.ok, cancel: _vm.cancel },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }